import { useState } from "react";

export function useCopyToClipboard() {
  const [copiedField, setCopiedField] = useState<string | null>(null);

  function copyToClipboard(value: string, field: string) {
    void navigator.clipboard.writeText(value);
    setCopiedField(field);
    setTimeout(
      () => setCopiedField((current) => (current === field ? null : current)),
      1500,
    );
  }

  return { copiedField, copyToClipboard };
}
